import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Linkedin } from 'lucide-react';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGetStarted = () => {
    onClose();
    navigate('/générer');  // Updated to correct path
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full mx-4 p-8">
        <div className="flex justify-end">
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Bienvenue sur <span className="gradient-text">PimpMyJob</span> !
          </h2>
          
          <p className="text-xl text-gray-600 mb-8">
            Prêt à transformer vos offres d'emploi en vecteurs d'engagement et de différenciation ?
          </p>

          <button
            onClick={handleGetStarted}
            className="bg-[#0A66C2] text-white px-8 py-4 rounded-xl hover:bg-[#004182] transition-colors flex items-center justify-center space-x-3 w-full"
          >
            <Linkedin className="w-6 h-6" />
            <span className="text-lg font-semibold">Commencer maintenant !</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;